import styled, { css } from "styled-components";
import MediaQueries from "./mediaQueries";
import { Colors } from "./colors";

export const Container = styled.div`
    width: 100%;
    margin: 0 auto;
    padding: 0 15px;
    /* height: 100%; */

    ${MediaQueries.BIGGER_THAN_TABLET} {
        padding: 0 20px;
    }

    ${MediaQueries.BIGGER_THAN_DESKTOP} {
        padding: 0 40px;
    }

    ${MediaQueries.BIGGER_THAN_WIDE} {
        padding: 0 60px;
    }

    ${MediaQueries.BIGGER_THAN_HUGE} {
        padding: 0 80px;
    }
`;

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
`;

export const Title = styled.h1`
    font-weight: bold;
    color: ${Colors.DarkText};
    font-size: 2rem;
`;

export const Subtitle = styled.h2`
    color: ${Colors.Ink};
    font-weight: normal;
    font-size: 1rem;
`;

export const Strong = styled.strong`
    color: ${Colors.DarkText};
    font-size: 1rem;
`;

export const Small = styled.small`
    color: ${Colors.Ink};
`;

export const Card = styled.div<{ height?: string }>`
    background: #fff;
    border-radius: 8px;
    border: 1px solid ${Colors.DarkBorder};
    padding: 15px;

    ${({ height }) =>
        height &&
        css`
            height: ${height};
        `};
`;
